
import type { State } from '../types';
import type TaskCollection from '../../models/TaskCollection';
import type SubTaskCollection from '../../models/SubTaskCollection';

export function getTasks(state: State): TaskCollection {
  return state.tasks.tasks;
}

export function isFetchingTasks(state: State): boolean {
  return state.tasks.isFetchingTasks;
}

export function isCreatingTask(state: State): boolean {
  return state.tasks.isCreatingTask;
}

export function getSubTasks(state: State): SubTaskCollection {
  return state.tasks.subTasks;
}



// WEBPACK FOOTER //
// ./src/redux/tasks/selectors.js